<template>
  <div class="common_head" :class="show_banner ? 'common_head_banner' : ''">
    <div class="headad_banner" v-if="show_banner">
      <div class="content">
        <div class="headad-text"></div>
        <div class="gift-text">豪华大礼 仅需1元</div>
        <div class="headad-btn" @click="showCode">戳我立即报名</div>
        <div class="close-btn" @click="hide_banner"></div>
      </div>
    </div>
    <Dialog
      center
      :visible.sync="show_code"
      custom-class="code-modal"
      width="200px"
    >
      <img src="../../assets/image/common/new/qrcode.png" />
    </Dialog>
    <div class="wrap">
      <span class="logo" @click="$router.push('/')">
        <img
          src="../../assets/image/common/new/logo_head.png"
          class="pic_full"
        />
      </span>
      <div class="right_menu">
        <span :class="active_menu == 0 ? 'menu_item active' : 'menu_item'">
          <router-link to="/">首页</router-link>
        </span>
        <!-- <span :class="active_menu == 7 ? 'menu_item active' : 'menu_item'">
          <router-link to="/public-course">公开课</router-link>
        </span> -->
        <!-- <span :class="active_menu == 1 ?'menu_item active':'menu_item'">课程体系</span> -->
        <span
          :class="active_menu == 2 ? 'menu_item active' : 'menu_item'"
          v-if="is_login"
        >
          <router-link to="/search-teacher">选课中心</router-link>
        </span>
        <div class="other_links" v-if="is_login">
          <span class="other_link">
            <router-link to="/user-benefit" class="other_link_text">
              <span class="icon-fuli"></span>
              <span
                class="text"
                :class="active_menu == 6 ? 'other_link_active' : ''"
                >专属邀请福利</span
              >
            </router-link>
          </span>
          <span class="other_link">
            <router-link
              to="/user/course"
              class="other_link_text"
              :class="active_menu == 5 ? 'other_link_active' : ''"
              >我的教室</router-link
            >
          </span>
          <!-- <span class="other_link">
            <router-link to="/user-point" class="other_link_text" :class="active_menu==8?'other_link_active':''">积分</router-link>
          </span> -->
        </div>
        <span class="dib" v-if="!is_login">
          <button class="login_btn hand_point" @click="bgshow(0, 1)">
            登录/注册
          </button>
          <!-- <button class="register_btn hand_point" @click="bgshow(0, 2)">
            注册
          </button> -->
        </span>
        <div class="info_show" v-else>
          <span class="name">
            <Menu mode="horizontal">
              <Submenu index="2">
                <template slot="title">
                  <span class="avatar">
                    <img :src="user_info.avatar" class="pic_full" />
                  </span>
                </template>
                <MenuItem
                  index="2-1"
                  @click="$router.push('/user-center-order')"
                  >订单中心</MenuItem
                >
                <MenuItem index="2-2" @click="$router.push('/user-point')"
                  >成长值</MenuItem
                >
                <MenuItem index="2-3" @click="$router.push('/user-center-buy')"
                  >学贝中心</MenuItem
                >
                <MenuItem index="2-4" @click="$router.push('/user-center-info')"
                  >个人设置</MenuItem
                >
                <MenuItem index="2-5" @click="logout">退出</MenuItem>
              </Submenu>
            </Menu>
          </span>
        </div>
      </div>
    </div>
    <div id="bg" v-if="bg">
      <div class="content" v-if="show_type == 1">
        <p class="close_icon">
          <i class="el-icon-close hand_point" @click="bgshow(1, '')"></i>
        </p>
        <div class="contentbox loginbox">
          <div class="contentbox-left">
            <div class="bg-text">英语思维启蒙 孩子爱学敢说</div>
          </div>
          <div class="contentbox-right">
            <div class="model_logo">
              <img src="../../assets/image/common/logo.png" class="pic_full" />
            </div>
            <div class="tab_items" v-if="!showbind">
              <div
                class="tab_item"
                :class="normal_login ? 'tab_active' : ''"
                @click="switch_login(true)"
              >
                短信登录
              </div>
              <div
                class="tab_item"
                :class="!normal_login ? 'tab_active' : ''"
                @click="switch_login(false)"
              >
                扫码登录
                <span class="tab_tag">推荐</span>
              </div>
            </div>
            <div class="bindtitle" v-if="showbind">绑定手机号，开启学习之旅</div>
            <div class="normal_loginbox" v-show="normal_login">
              <div class="phone">
                <input
                  maxlength="11"
                  type="text"
                  autofocus="off"
                  placeholder="请输入手机号"
                  v-model="account"
                />
              </div>
              <div class="code_area pr">
              <input
                type="text"
                autofocus="off"
                placeholder="请输入验证码"
                v-model="code"
              />
              <button class="get_code hand_point" @click="get_account_code">
                {{ btn_text }}
              </button>
            </div>
              <!-- <div class="pwd">
                <input type="password" placeholder="请输入密码" v-model="pwd" />
              </div> -->
              <p class="err_info">{{ err_info }}</p>
              <button
                @click="login(0)"
                class="login_register hand_point"
                v-if="!is_logining"
              >
                账号登录
              </button>
              <button class="login_register" disabled v-if="is_logining">
                <i class="el-icon-loading" style="margin-right: 10px"></i
                >账号登录
              </button>
            </div>
            <div class="wechat_loginbox" v-show="!normal_login">
              <div class="scancodebox" v-if="!showbind">
                <div class="qrcodebox" id="qrcodebox">
                  <img :src="codeurl" alt="" class="pic_full" v-if="codeurl" />
                  <div class="codeerr" v-if="codeerr" @click="getqrcode">{{ codeerr }}</div>
                </div>
                <div class="qrcode_text">打开 微信 扫一扫</div>
                <p class="err_info">{{ err_info_wechat }}</p>
              </div>
              <div class="bindbox" v-if="showbind">
                <div class="phone pr">
                  <input
                    maxlength="11"
                    type="text"
                    autofocus="off"
                    placeholder="请输入手机号"
                    v-model="bindmobile"
                  />
                </div>
                <div class="code_area pr">
                  <input
                    type="text"
                    autofocus="off"
                    placeholder="请输入验证码"
                    v-model="bindcode"
                  />
                  <button class="get_code hand_point" @click="sendsmsbind">
                    {{ bind_text }}
                  </button>
                </div>
                <button class="login_register bindregister" @click="accountbind">
                  <i class="el-icon-loading" v-if="is_binding"></i>绑定
                </button>
              </div>
            </div>

            <!-- <div class="other_way" v-if="normal_login">
              <div class="fl">
                免费体验
                <span @click="bgshow(0, 2)">账号注册</span>
              </div>
              <div class="fr">
                忘记密码
                <router-link to="./user-center-pwd">立刻找回</router-link>
              </div>
              <div class="clear"></div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="content" v-if="show_type == 2">
        <p class="close_icon">
          <i class="el-icon-close hand_point" @click="bgshow(1, '')"></i>
        </p>
        <div class="contentbox registerbox">
          <div class="contentbox-left">
            <div class="bg-text">英语思维启蒙 孩子爱学敢说</div>
          </div>
          <div class="contentbox-right">
            <div class="model_logo">
              <img
                src="../../assets/image/common/new/logo_head.png"
                class="pic_full"
              />
            </div>
            <div class="phone pr">
              <input
                maxlength="11"
                type="text"
                autofocus="off"
                placeholder="请输入手机号"
                v-model="phone"
              />
            </div>
            <div class="code_area pr">
              <input
                type="text"
                autofocus="off"
                placeholder="请输入验证码"
                v-model="code"
              />
              <button class="get_code hand_point" @click="get_code">
                {{ btn_text }}
              </button>
            </div>
            <div class="pwd pr">
              <input type="password" placeholder="请输入密码" v-model="pwd" />
            </div>
            <p class="err_info">{{ err_info }}</p>

            <button
              @click="login(1)"
              class="login_register hand_point"
              v-if="!is_reging"
            >
              注册
            </button>
            <button class="login_register" v-if="is_reging" disabled>
              <i class="el-icon-loading" style="margin-right: 10px"></i>注册
            </button>
            <div class="other_way register_bottom">
              <div class="fl">
                已有账号?
                <span @click="bgshow(0, 1)">立即登录</span>
              </div>
              <div class="fr">
                <span @click="wechat_register">微信免注册登录</span>
              </div>
              <div class="clear"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { common } from "../../../common.js";
import { Menu, Submenu, MenuItem, Dialog } from "element-ui";
export default {
  props: ["active_menu", "show_type", "bg", "mobile", "callback", "switch"], //show_type 1登录2注册
  components: {
    Menu,
    Submenu,
    MenuItem,
    Dialog,
  },
  data: function () {
    return {
      is_login: false,
      is_logining: false,
      is_reging: false,
      user_info: "",
      err_info: "", //表单错误提示
      btn_text: "获取验证码",
      is_counting: false, //是否正在获取验证码
      account: "",
      phone: this.mobile || "",
      counter: "",
      code: "",
      pwd: "",
      quick_enter_url: "",
      quick_enter_close: true,
      normal_login: true,
      show_banner: true,
      show_code: false,
      timer: null,
      codeurl: "",
      codeerr: "",
      qr_id: "",
      bindis_counting: false, //绑定验证码倒计时
      bind_text: "获取验证码",
      bindmobile: "", //绑定手机号
      is_binding: false, //正在绑定
      showbind: false,
      bindcode: "",
      err_info_wechat: "",
    };
  },
  mounted: function () {
    this.get_info();
    // 暂时关闭，影响调试
    this.checking_status();
  },
  methods: {
    bgshow(type, type_2) {
      // 切换为普通密码登录界面
      this.switch_login(true);
      this.err_info = "";
      if (this.switch) {
        this.switch(type == 0 ? true : false, type_2);
      } else {
        this.bg = type == 0 ? true : false;
        this.show_type = type_2;
      }

    },
    get_infotime() {
      let self = this;
      common.requestFun(self, "get", "/student/profile", {}, (res) => {
        if (res.data.code == 200) {
          self.user_info = res.data.data;
          self.is_login = true;
          self.callback && self.callback(true);
          if (self.timer) {
            clearInterval(self.timer);
          }
        }
      });
    },
    get_info() {
      let self = this;
      common.requestFun(self, "get", "/student/profile", {}, (res) => {
        if (res.data.code == 200) {
          self.user_info = res.data.data;
          self.is_login = true;
          self.callback && self.callback(true);
        } else {
          self.is_login = false;
          self.callback && self.callback(false);
        }
      });
    },
    get_code() {
      //获取验证码
      let self = this;
      if (this.checkPhone(this.phone) && !this.is_counting) {
        common.requestFun(
          self,
          "post",
          "/smscode",
          {
            mobile: self.phone,
            role: "student",
          },
          (res) => {
            if (res.data.code == 200) {
              let count = 60;
              this.err_info = "";
              let timeCounter = setInterval(function () {
                count--;
                if (count > 0) {
                  self.is_counting = true;
                  self.btn_text = count + "S后重新获取";
                } else {
                  self.is_counting = false;
                  self.btn_text = "获取验证码";
                  clearInterval(timeCounter);
                }
              }, 1000);
            } else {
              self.err_info = res.data.msg;
            }
          }
        );
      } else {
        this.err_info = "请输入正确的手机号";
      }
    },
    get_account_code() {
      //获取验证码
      let self = this;
      if (this.checkPhone(this.account) && !this.is_counting) {
        common.requestFun(
          self,
          "post",
          "/smscode",
          {
            mobile: self.account,
            role: "student",
          },
          (res) => {
            if (res.data.code == 200) {
              let count = 60;
              this.err_info = "";
              let timeCounter = setInterval(function () {
                count--;
                if (count > 0) {
                  self.is_counting = true;
                  self.btn_text = count + "S后重新获取";
                } else {
                  self.is_counting = false;
                  self.btn_text = "获取验证码";
                  clearInterval(timeCounter);
                }
              }, 1000);
            } else {
              self.err_info = res.data.msg;
            }
          }
        );
      } else {
        this.err_info = "请输入正确的手机号";
      }
    },
    checkPhone(phone) {
      //检测手机号合法性
      let reg = /^1\d{10}$/;
      return reg.test(phone);
    },
    checkMail(mail) {
      let reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      return reg.test(mail);
    },
    login(type) {
      let self = this;
      if (type == 0) {
        //登录
        if (this.checkPhone(this.account) && this.code) {
          self.is_logining = true;
          common.requestFun(
            self,
            "post",
            "/student/captcha/login",
            {
              account: self.account,
              captcha: self.code,
            },
            (res) => {
              if (res.data.code == 200) {
                self.get_info();
                self.err_info = "";
                self.is_login = true;
                if (!self.callback) {
                  self.bg = false;
                } else {
                  self.callback(false);
                }
                self.is_logining = false;
              } else {
                self.err_info = res.data.msg;
                self.is_logining = false;
              }
            }
          );
        } else {
          self.err_info = "请输入正确的信息";
        }
      }
      if (type == 1) {
        //注册
        if (this.checkPhone(this.phone) && this.pwd && this.code) {
          self.is_reging = true;
          common.requestFun(
            self,
            "post",
            "/student/register",
            {
              ccc: "86",
              code: self.code,
              mobile: self.phone,
              password: self.pwd,
              recommend_mobile: null,
            },
            (res) => {
              if (res.data.code == 200) {
                self.err_info = "";
                if (!self.callback) {
                  self.bg = false;
                } else {
                  self.callback(false);
                }
                self.is_reging = false;
                // 注册成功后刷新
                self.get_info();
              } else {
                let err_info = res.data.error
                  ? (res.data.error.code ? res.data.error.code[0] : null) ||
                    (res.data.error.mobile ? res.data.error.mobile[0] : null) ||
                    (res.data.error.password
                      ? res.data.error.password[0]
                      : null)
                  : res.data.msg;
                self.err_info = err_info;
                self.is_reging = false;
              }
            }
          );
        } else {
          self.err_info = "请输入正确的信息";
        }
      }
    },
    handleSelect(key) {
      if (key == "2-2") {
        //退出登录操作
        this.logout();
      }
    },
    logout() {
      let self = this;
      common.requestFun(self, "post", "/student/logout", {}, (res) => {
        if (res.data.code == 200) {
          self.is_login = false;
          self.$router.push("./");
        } else {
          if (res.data.msg && res.data.code == 401) {
            self.$message({
              message: "请登录",
              type: "error",
              center: true,
            });
          }
        }
      });
    },
    checking_status() {
      //检查课程状态
      let self = this;
      this.counter = setInterval(function () {
        common.requestFun(self, "get", "/student/class/check", {}, (res) => {
          if (res.data.code == 200) {
            if (res.data.data && res.data.data.reservation_id) {
              if (!self.quick_enter_url) {
                common.requestFun(
                  self,
                  "get",
                  "/student/classroom/" + res.data.data.reservation_id,
                  {},
                  (res_1) => {
                    if (res_1.data.code == 200) {
                      if (res_1.data.data) {
                        self.quick_enter_url = res_1.data.data.url;
                        self.$notify({
                          title: "提示",
                          dangerouslyUseHTMLString: true,
                          type: "warning",
                          duration: 0,
                          message: `您有课程正在进行中，点击<a href="${self.quick_enter_url}" target="_blank">进入课堂</a>`,
                          onClose: self.close_enter_model,
                        });
                        self.quick_enter_close = false;
                      }
                    }
                  }
                );
              } else {
                if (self.quick_enter_close) {
                  self.$notify({
                    title: "提示",
                    dangerouslyUseHTMLString: true,
                    type: "warning",
                    duration: 0,
                    message: `您有课程正在进行中，点击<a href="${self.quick_enter_url}" target="_blank">进入课堂</a>`,
                    onClose: self.close_enter_model,
                  });
                  self.quick_enter_close = false;
                }
              }
            }
          }
        });
      }, 5000);
    },
    close_enter_model() {
      this.quick_enter_close = true;
    },
    switch_login(is_normal) {
      let self = this;
      !is_normal && (this.err_info = "");
      this.normal_login = is_normal;
      if (this.timer) {
        clearInterval(this.timer);
      }
      if (!is_normal) {
        self.showbind = false;
        self.getqrcode();
      }
    },
    hide_banner() {
      this.show_banner = false;
    },
    showCode() {
      this.show_code = true;
    },
    // 获取微信二维码
    getqrcode() {
      let self = this;
      this.bindcode = '';
      common.requestFun(
        self,
        "get",
        "/auth/student/wechat/qrcode",
        {},
        (res) => {
          if (res.data.code == 200) {
            self.codeurl = res.data.data.qrcode;
            self.qr_id = res.data.data.qr_id;
            self.codeerr = "";
            self.timer = setInterval(() => {
              self.scanqrcode();
            }, 500);
          } else {
            self.$message({
              message: "获取二维码失败",
              type: "error",
              center: true,
            });
            self.codeerr = "点击重新获取";
          }
        }
      );
    },
    scanqrcode() {
      let self = this;
      common.requestFun(
        self,
        "get",
        "/auth/student/wechat/qrcode/scanned",
        {
          qr_id: self.qr_id,
        },
        (res) => {
          if (res.data.code == 200) {
            var status = res.data.data.status;
            switch (status) {
              case "NOT_SCANNED":
                // 等待扫码不处理
                break;
              case "EXPIRED":
                // 过期
                self.codeerr = "已过期，点击刷新";
                self.timer && clearInterval(this.timer);
                break;
              case "LOGGED_IN":
                // 登录
                self.timer && clearInterval(this.timer);
                self.get_info();
                if (!self.callback) {
                  self.bg = false;
                } else {
                  self.callback(false);
                }
                break;
              case "NEED_TO_BIND":
                // 绑定
                self.timer && clearInterval(this.timer);
                self.showbind = true;
                break;
              default:
                break;
            }
          }
        }
      );
    },
    sendsmsbind() {
      //获取验证码
      if(this.bindis_counting){
        return;
      }
      let self = this;
      if (this.checkPhone(this.bindmobile) && !this.bindis_counting) {
        common.requestFun(
          self,
          "post",
          "/sms/weixinbind",
          {
            mobile: self.bindmobile,
          },
          (res) => {
            if (res.data.code == 200) {
              let count = 60;
              let timeCounter = setInterval(function () {
                count--;
                if (count > 0) {
                  self.bindis_counting = true;
                  self.bind_text = count + "S后重新获取";
                } else {
                  self.bindis_counting = false;
                  self.bind_text = "获取验证码";
                  clearInterval(timeCounter);
                }
              }, 1000);
            } else {
              self.$message({
                message: res.data.msg,
                type: "error",
                center: true,
              });
            }
          }
        );
      } else {
        self.$message({
          message: "请输入正确的手机号",
          type: "error",
          center: true,
        });
      }
    },
    // 绑定登录
    accountbind() {
      if(this.is_binding){
        return;
      }
      let self = this;
      if (!this.checkPhone(this.bindmobile)) {
        self.$message({
          message: "请输入正确的手机号",
          type: "error",
          center: true,
        });
        return;
      }
      if (!this.bindcode) {
        self.$message({
          message: "请输入短信验证码",
          type: "error",
          center: true,
        });
        return;
      }
      this.is_binding = true;
      common.requestFun(
        self,
        "post",
        "/auth/student/weixinbind",
        {
          mobile: self.bindmobile,
          qr_id: self.qr_id,
          code: self.bindcode
        },
        (res) => {
          if (res.data.code == 200) {
            self.get_info();
            if (!self.callback) {
              self.bg = false;
            } else {
              self.callback(false);
            }
          } else {
            self.$message({
              message: res.data.msg,
              type: "error",
              center: true,
            });
          }
          self.is_binding = false;
        }
      );
    },
    wechat_register(){
      this.bgshow(0,1);
      this.switch_login(false);
    }
  },
  watch: {
    mobile(value) {
      this.phone = value;
    },
  },
};
import "../../assets/css/common.css";
</script>
<style scoped src="./common_head.css"></style>
